import { useQuery } from "react-query";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";
import type { ApiResponse, CommunityMember } from "../../types";

interface UseCommunityMemberSearchOptions {
  enabled?: boolean;
  excludeCommunityMemberIds?: number[];
}

interface UseCommunityMemberSearchReturn {
  records: CommunityMember[];
}

export const useCommunityMemberSearch = (
  query: string,
  {
    excludeCommunityMemberIds = [],
    enabled = true,
  }: UseCommunityMemberSearchOptions = {},
): UseCommunityMemberSearchReturn => {
  const { data } = useQuery<ApiResponse<CommunityMember>>(
    internalApi.search.communityMembers.index({
      params: {
        query,
        filters: {
          exclude_ids: excludeCommunityMemberIds,
        },
      },
    }),
    {
      enabled: enabled && !!query?.length,
    },
  );

  return {
    records: data?.records || [],
  };
};
